import { AccountIcon } from 'features/navigation/assets/icons/icons';
import styles from './MainNavbarAccount.module.css';
import GuiVersion from 'components/shared/gui/GuiVersion';
import LogOut from 'components/shared/gui/LogOut';
import { useContext } from 'react';
import GuiContext from 'config/context/guiContext';

const MainNavbarAccount = () => {
    const {
        selected: { selectedAccount, selectedServer },
    } = useContext(GuiContext);
    return (
        <div className={styles.main_navbar_account}>
            <div className={styles.top_line}>
                <div className={styles.avatar}>
                    <AccountIcon />
                </div>
                <div className={styles.account_info}>
                    <span>User: {selectedAccount}</span>
                    <span>Server: {selectedServer}</span>
                </div>
            </div>
            <div className={styles.bottom_line}>
                <GuiVersion />
                <LogOut />
            </div>
        </div>
    )
}

export default MainNavbarAccount